import { useLingui } from '@lingui/react/macro'
import { ColorPicker } from 'antd'
import { AggregationColor } from 'antd/es/color-picker/color'
import React from 'react'
import styled from 'styled-components'

/* AntD's smallest built-in trigger is far larger than a table-row swatch;
   the picker's supported children API replaces the trigger outright, so no
   .ant-* internals need overriding. */
const SmallSwatchTrigger = styled.button<{ $color: string }>`
  display: inline-flex;
  flex-shrink: 0;
  width: 0.875rem;
  height: 0.875rem;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 0.1875rem;
  background: ${({ $color }) => $color};
  cursor: pointer;
`

interface ColorSwatchProps {
  color: string
  onChangeColor: (color: string) => void
  size?: 'default' | 'sm'
}

export const ColorSwatch: React.FC<ColorSwatchProps> = ({
  color,
  onChangeColor,
  size = 'default',
}) => {
  const { t } = useLingui()

  const handleColorChange = (value: AggregationColor) => {
    onChangeColor(value.toHexString())
  }

  if (size === 'sm') {
    return (
      <ColorPicker value={color} onChange={handleColorChange}>
        <SmallSwatchTrigger
          type='button'
          aria-label={t`Pen color`}
          $color={color}
        />
      </ColorPicker>
    )
  }
  return <ColorPicker value={color} onChange={handleColorChange} />
}
